import { useGetRegionsRequest } from "@/api/useGetRegionsRequest";
import { SelectOptions } from "../select-options";
import { useTranslations } from "next-intl";

export default function SelectRegionFlow({
  onSelect,
}: {
  onSelect: (selectedValue) => void;
}) {
  const { data } = useGetRegionsRequest();
  const t = useTranslations();

  const options = data?.data?.data
    ? data?.data?.data?.map((region) => {
        return {
          id: region.regionId,
          mainText: region.regionName,
        };
      })
    : [];

  return (
    <SelectOptions
      options={options}
      onSelect={onSelect}
      searchPlaceholder={t("search_for_region")}
      translation={false}
    />
  );
}
